import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldOff, SearchX } from 'lucide-react';

interface AccessDeniedProps {
  message: string;
  statusCode?: number;
}

const AccessDenied: React.FC<AccessDeniedProps> = ({
  message,
  statusCode = 403,
}) => {
  const navigate = useNavigate();
  const isNotFound = statusCode === 404;

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-6">
      <div className="w-16 h-16 rounded-full bg-terracota/10 flex items-center justify-center mb-6">
        {isNotFound ? (
          <SearchX size={32} className="text-terracota" />
        ) : (
          <ShieldOff size={32} className="text-terracota" />
        )}
      </div>
      <p className="text-sm font-semibold text-terracota uppercase tracking-widest mb-2">
        {isNotFound ? 'Não encontrado' : 'Acesso negado'}
      </p>
      <h2 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-3">
        {message}
      </h2>
      <p className="text-gray-500 dark:text-gray-400 text-sm mb-8 max-w-sm">
        {isNotFound
          ? 'O conteúdo que você está tentando acessar não foi encontrado. Entre em contato com o suporte se acredita que isso é um erro.'
          : 'Sua matrícula atual não permite acessar este conteúdo. Entre em contato com o suporte se acredita que isso é um erro.'}
      </p>
      <button
        onClick={() => navigate('/meus-cursos')}
        className="px-6 py-2 rounded-lg bg-terracota text-white text-sm font-medium hover:bg-terracota/90 transition-colors"
      >
        Ver meus cursos
      </button>
      {statusCode && (
        <p className="mt-6 text-xs text-gray-400">Código: {statusCode}</p>
      )}
    </div>
  );
};

export default AccessDenied;
